import http from "../http";

/**
 * Get user profile
 * @returns {Promise} API response
 */
export function getProfile() {
  return http.get("/buyer/profile");
}

/**
 * Update user profile
 * @param {Object} params - Profile update data
 * @returns {Promise} API response
 */
export function updateProfile(params) {
  return http.post("/buyer/profile/update", params);
}

/**
 * Update user password
 * @param {Object} params - Password update data
 * @returns {Promise} API response
 */
export function updatePassword(params) {
  return http.put("/buyer/password/update", params);
}

/**
 * Check user PIN
 * @param {Object} params - PIN check data
 * @returns {Promise} API response
 */
export function checkPin(params) {
  return http.post("/buyer/pin/check", params);
}

/**
 * Add new PIN
 * @param {Object} params - PIN creation data
 * @returns {Promise} API response
 */
export function addPin(params) {
  return http.post("/buyer/pin/add", params);
}

/**
 * Update existing PIN
 * @param {Object} params - PIN update data
 * @returns {Promise} API response
 */
export function updatePin(params) {
  return http.put("/buyer/pin/update", params);
}

/**
 * Get balance history
 * @param {Object} params - Query parameters
 * @returns {Promise} API response
 */
export function getBalanceHistory(params) {
  return http.get("/buyer/balance/history", { params });
}

/**
 * Get balance history detail
 * @param {string|number} balanceHistoryId - Balance history entry ID
 * @returns {Promise} API response
 */
export function getBalanceHistoryDetail(balanceHistoryId) {
  return http.get(`/buyer/balance/history/${balanceHistoryId}`);
}

/**
 * Get list of banks
 * @returns {Promise} API response
 */
export function getBankList() {
  return http.get("/buyer/bank/list");
}

/**
 * Get bank accounts
 * @returns {Promise} API response
 */
export function getBankAccounts() {
  return http.get("/buyer/bank/account");
}

/**
 * Check bank account
 * @param {Object} params - Bank account check data
 * @returns {Promise} API response
 */
export function checkBankAccount(params) {
  return http.post("/buyer/bank/account/check", params);
}

/**
 * Add bank account
 * @param {Object} params - Bank account creation data
 * @returns {Promise} API response
 */
export function addBankAccount(params) {
  return http.post("/buyer/bank/account/add", params);
}

/**
 * Update bank account
 * @param {string|number} bankAccountId - Bank account ID
 * @param {Object} params - Bank account update data
 * @returns {Promise} API response
 */
export function updateBankAccount(bankAccountId, params) {
  return http.put(`/buyer/bank/account/update/${bankAccountId}`, params);
}

/**
 * Delete bank account
 * @param {string|number} bankAccountId - Bank account ID
 * @returns {Promise} API response
 */
export function deleteBankAccount(bankAccountId) {
  return http.delete(`/buyer/bank/account/delete/${bankAccountId}`);
}

/**
 * Get all addresses
 * @returns {Promise} API response
 */
export function getAddresses(type) {
  if (type === undefined || type === null) {
    return http.get("/buyer/address");
  } else {
    return http.get("/buyer/address?type=" + type);
  }
}

/**
 * Get address detail
 * @param {string|number} addressId - Address ID
 * @returns {Promise} API response
 */
export function getAddressDetail(addressId) {
  return http.get(`/buyer/address/${addressId}`);
}

/**
 * Add new address
 * @param {Object} params - Address creation data
 * @returns {Promise} API response
 */
export function addAddress(params) {
  return http.post("/buyer/address/add", params);
}

/**
 * Update address
 * @param {string|number} addressId - Address ID
 * @param {Object} params - Address update data
 * @returns {Promise} API response
 */
export function updateAddress(addressId, params) {
  return http.put(`/buyer/address/update/${addressId}`, params);
}

/**
 * Delete address
 * @param {string|number} addressId - Address ID
 * @returns {Promise} API response
 */
export function deleteAddress(addressId) {
  return http.delete(`/buyer/address/delete/${addressId}`);
}

/**
 * Set address as main
 * @param {string|number} addressId - Address ID
 * @returns {Promise} API response
 */
export function setMainAddress(addressId) {
  return http.patch(`/buyer/address/main/${addressId}`);
}

/**
 * Get app version
 * @returns {Promise} API response
 */
export function getVersion() {
  return http.get("/buyer/version")
}
